<form [formGroup]="form" class="row">
  <section class="col-2">
    <input class="col-12" type="text" formControlName="vin" (keypress)="emit()" (input)="emit()">
    @if (form.get('vin').dirty && !form.get('vin').valid) {
      <app-error-field [errorMessage]="'valid-vin-required'"
      ></app-error-field>
    }
  </section>
  @if (displayMileage) {
    <section class="col-2">
      <input class="col-12" type="number" formControlName="mileage" (keypress)="emit()" (input)="emit()">
      @if (form.get('mileage').dirty && !form.get('mileage').valid) {
        <app-error-field
        [errorMessage]="'valid-mileage-required'"></app-error-field>
      }
    </section>
  }

  <section class="col-2">
    <input class="col-12" type="date" formControlName="firstRegistration" (keypress)="emit()" (input)="emit()">
    @if (form.get('firstRegistration').dirty && !form.get('firstRegistration').valid || !firstRegistrationFallsWithinRange) {
      <app-error-field
      [errorMessage]="'valid-first-registration-is-required'"></app-error-field>
    }
  </section>

</form>
